import { Typography } from '@mui/joy';
import { PencilSimpleLine } from '@phosphor-icons/react';

import { UpsertCustomerButton } from 'jobs/components/JobDetails/tabs/CustomerList/actions';
import { IJobCustomer } from 'jobs/types';
import { Color, Level } from 'theme/enums';

interface IProps {
  jobId: number;
  projectId: number;
  data: IJobCustomer;
}

export const ActionsCell = ({ jobId, projectId, data }: IProps) => {
  if (!data) {
    return null;
  }

  return (
    <UpsertCustomerButton
      jobId={jobId}
      projectId={projectId}
      customer={data}
      buttonElement={
        <Typography color={Color.PRIMARY} level={Level.BODY_SM} sx={{ cursor: 'pointer' }}>
          <PencilSimpleLine />
        </Typography>
      }
    />
  );
};
